import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CustomCart } from '@cart/const';
import { InViewportDirective } from '@sdvor/shared/ui';
import { BonusOrderWidgetComponent } from '@sdvor/shared/ui/v2';
import { DeviceService } from '@shared/services';
import { BonusSystemFeatureAvailableService } from '@user/feature';
import { CartTotalsCouponComponent } from './cart-totals-coupon';
import { CartTotalsFloatingComponent } from './cart-totals-floating';
import { CartTotalsListComponent } from './cart-totals-list';
import { CartTotalsOrderComponent } from './cart-totals-order';

@Component({
  selector: 'sd-cart-totals',
  imports: [
    BonusOrderWidgetComponent,
    CartTotalsListComponent,
    CartTotalsOrderComponent,
    CartTotalsFloatingComponent,
    CartTotalsCouponComponent,
    InViewportDirective,
  ],
  templateUrl: './cart-totals.component.html',
  styleUrls: ['./cart-totals.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartTotalsComponent {
  private readonly deviceService = inject(DeviceService);

  readonly cart = input.required<CustomCart>();

  protected readonly isBonusFeatureAvailableForUser = toSignal(
    inject(BonusSystemFeatureAvailableService).isFeatureAvailableForUser(),
    { initialValue: false },
  );

  protected readonly providingBonusForOrder = computed(() => {
    if (!this.isBonusFeatureAvailableForUser()) {
      return undefined;
    }

    return this.cart()?.bonus?.providingBonusForOrder;
  });

  protected readonly isTabletMdDown = toSignal(this.deviceService.isTabletMdDown$, { initialValue: false });

  private readonly isOrderBelowViewport = signal(false);

  protected readonly showFloating = computed(() => this.isOrderBelowViewport() && this.isTabletMdDown());

  onIntersectEntry(entry: IntersectionObserverEntry): void {
    if (entry.isIntersecting) {
      this.isOrderBelowViewport.set(false);
    } else {
      this.isOrderBelowViewport.set(entry.boundingClientRect.top >= 0);
    }
  }
}
